import { FilterTargetSimple } from '@repo/common/components/Filter/FilterTarget/FilterTargetSimple';
import { observer } from 'mobx-react-lite';
import { inboxFeatureStore } from '../store';

export const InboxFilterPills = observer(() => {
	const { selectedEvents, clearSelectedEvents } = inboxFeatureStore;

	if (selectedEvents.length === 0) return null;

	const getLabel = () => {
		if (selectedEvents.length === 1) {
			const [eventType] = selectedEvents;
			return `Type is ${eventType.label}`;
		}
		return `${selectedEvents.length} types selected`;
	};

	return (
		<FilterTargetSimple
			style={{ minWidth: 158 }}
			label={getLabel()}
			hasValue={true}
			onClear={clearSelectedEvents}
			onToggle={() => {}}
		/>
	);
});
